var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{attrs:{"bordered":_vm.option.border,"bodyStyle":_vm.bodyStyle}},[_vm._t("cardBody")],2)}
var staticRenderFns = []

export { render, staticRenderFns }